export default __webpack_public_path__ + "static/media/LoadingSVG.073ec1f9.svg";